/**
 * Method of ensuring the creation of a string array that contains every possible value of a string union type.
 * Its kind of boiler-plate heavy but is the best way I could think of given the etherial nature of TypeScript's
 * type system. There may be a better way by generating metadata?...
 *
 * @param valuesAsKeys - An object where every value of the string union is a property name.
 * @returns All the values of the string union
 */
export function getAllStringUnionValues<TStringUnion extends string>(valuesAsKeys: {
    [K in TStringUnion]: any;
}): TStringUnion[] {
    const result = Object.getOwnPropertyNames(valuesAsKeys);
    return result as any;
}

export type ClassType<TType = any> = new (...args: any[]) => TType;

export type StringKey<T> = Extract<keyof T, string>;

export type NullableOptional<T> = T | null | undefined;

export type Omit<T, K extends keyof T> = OptionalOmit<T, K>;

export type OptionalOmit<T, K> = Pick<T, Exclude<keyof T, K>>;

export type KeysOf<T> = Array<keyof T>;

export type Subset<TSource, TSubset extends KeysOf<TSource>> = Pick<TSource, TSubset[number]>;

export type TypedExtract<T, K extends T> = Extract<T, K>;

export type Nullable<T> = { [P in keyof T]: T[P] | null };

export type MutablePartial<T> = { -readonly [P in keyof T]?: T[P] }; // Remove readonly, and add ?

/**
 * Use this in any "catch" statement or Promise rejection handler.
 * In JavaScript, any value can be thrown at any time, so we can't guarantee any sort of type safety. It's also used
 * as a form of "goto", which is infamously considered harmful.
 * Avoid "throw" or Promise rejections! Use our "Result" functionality instead.
 */
export type AnyThrowable = any;

export type NonEmptyArray<T> = [T, ...T[]];

export type NonEmptyReadonlyArray<T> = readonly [T, ...T[]];
